import Structure from 'components/3cat/Structure';

export default function TabPanel(props) {
    const { id, ancestorProps } = props;
    const { activeTabWebview } = ancestorProps;
    if (activeTabWebview === id) {
        return (
            <div key={`tab-panel-content-${id}`}>
                <Structure {...props} />
            </div>
        );
    }
    return <></>;
}
